import { render, staticRenderFns } from "./TestList.vue?vue&type=template&id=4ab61632&scoped=true&"
import script from "./TestList.vue?vue&type=script&lang=js&"
export * from "./TestList.vue?vue&type=script&lang=js&"
import style0 from "./TestList.vue?vue&type=style&index=0&id=4ab61632&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab61632",
  null
  
)

export default component.exports